import { CircularProgress } from "@material-ui/core";
const HeaderLoadingIcon = () => (<CircularProgress data-identification="notification-icons-loading" color="inherit" size={20} style={{ margin: "0 1rem" }}/>);
export default HeaderLoadingIcon;
